import ReactStrapTable from 'components/reactStrapTable';
import React, { useState,useEffect } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import Drawer from 'components/Drawer';
// import SearchOrderDrawer from '../SearchOrder/SearchOrderDrawer';
import EyeIcon from 'assets/icon/icon-icon-options-view-patient.svg';
import EyeIconHover from 'assets/icon/icon-icon-options-view-patient_hover.svg';
// import ViewPurchaseOrder from '../SearchOrder/ViewSearchOrder';
import AttachIcon from 'assets/icon/icon-icon-options-attachment.svg';
import AttachHoverIcon from 'assets/icon/icon-icon-options-attachment_hover.svg';
import Download from 'assets/icon/download.svg';
import DownlaodHower from 'assets/icon/download_hover.svg';
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import Delete from 'assets/icon/icon-icon-options-delete.svg';
import DeleteHower from 'assets/icon/icon-icon-options-delete-hover.svg';
import Pause from 'assets/icon/icon-icon-options-pause-claim.svg'
import Pending from "assets/icon/AuditHold.svg";
import PendingHover from "assets/icon/AuditHoldHover.svg";

// import Attachments from '../PurchaseOrderAttachments';
import { Formik } from 'formik';
import useAxios from 'hooks/useAxios';
import { toast } from 'react-toastify';
import AuditProgramNotes from 'components/AuditProgramNotes';
import { ModuleAccess } from 'utils/moduleaccess';
import { cloneDeep } from 'lodash';



let instialFilters={
  currentPage: 1,
  pageSize: 100,
  order: 'desc',
  orderBy: 'ChargeAuditID',
  filters: [],
  AccumulatorIDs:[],
  // pageSize:"order\":\"desc\",\"orderBy\":\"ChargeAuditID\",\"filters\":[],\"AccumulatorIDs\":[14],\"FromDate\":null,\"ToDate\":null,\"AuditCount\":0,\"AccountTypeID\":0}
}


const GenerateAuditTable = (props) => {
    const {
      totalRecords,
      filters,
      onPageChange,
        toggleViewAudit,
        manvalConfig,
        manvalPharmacy,
        orgId,
        rowData,
        tableData1,
        search,
        collapseSider,
        toggleSider,
        loading,
        setLoading,
        ceid,
        //  setTableData,
        setTotalRecords
        
        
    } = props;
    console.log(rowData,"rowData")
    
    const [tableData, setTableData] = useState([]);
    const [isPODetailsOpen, setisPODetailsOpen] = useState(false);
    const [drawerPODetails, setDrawerPODetails] = useState('');
    const [isOpenView, setOpenView] = useState(false);
    const [isOpenHistory, setOpenHistory] = useState(false);
    const [selectedRow, setselectedRow] = useState({});
    const [selectedRowHistory, setSelectedRowHistory] = useState({});
    const [commentDrawer, setCommentDrawer] = useState(false);
    const [commentRowData, setCommentRowData] = useState("");
    const [modal, setModal] = useState(false);
      const [columnFilters, setColumnFilters] = useState([]);

     const API = useAxios();
    const toggle = (row) =>{
      setselectedRow(row)
      setModal(!modal);
    } 

    useEffect(()=>{
setCommentDrawer(false);
    },[orgId])


useEffect(()=>{
  setTableData(tableData1)
},[tableData1])
    useEffect(() => {
      if(rowData.length>1){
    handelAudititems();
      }
    }, [])

    const togglePODetailsDrawer = () => {
        setisPODetailsOpen(!isPODetailsOpen);
        setDrawerPODetails('');
      };
      
    const toggleViewPODetailsDrawer = () => {
        setOpenView(!isOpenView);
        // setDrawerPODetails('');
      };
      const toggleAttachPODetailsDrawer = (rowData) => {
        setCommentDrawer(!commentDrawer);
        setCommentRowData(rowData);

        // setDrawerPODetails('');
      };
    const handelViewAudit = async (rowData) => {
         await toggleViewAudit(rowData);

    }
    const handelAddCoveredEntity = async (rowData) => {
        await manvalPharmacy();

   }
    
    // const renderWacPrice = () => {
    //     // if (hasPermission('EDT'))
    //         return <Button
    //             className='text-primary p-0 text-decoration-none'
    //             color='link'
    //             onClick={() => handelWacPrice()}
    //             title='Edit Covered Entity'

    //         >
    //             <HoverImage src={EditIcon}
    //                 hoverSrc={EditHoverIcon}
    //                 alt='' />
    //         </Button>
    // }

    const renderConfigButton = () => {

        return <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => handleConfig()}
            title='Client Configuration'

        >
            <HoverImage
                src={ConfigIcon}
                hoverSrc={ConfigIconHover}
                alt='' />
        </Button>
    }
    const handelAudititems= async()=>{
      debugger
      if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
      const filterObj = cloneDeep(search);
      setLoading(true)
             try{
              const { data } = await API.post(
                `SBTenant/${orgId.tenantID}/AuditTool/GetAuditIAlltems/${rowData.chargeAuditID}`,filterObj,
                { hasDefaultURL: true }
              );
              if(data?.items?.length > 0){
              setTableData(data.items);
              setTotalRecords(data.totalRecords);            
              }
              else{
                setTableData([]);
              }
              setLoading(false)
             }
            catch{
            setLoading(false)
            }
          }

    const handelAll = async(rowdata, status )=>{
      setLoading(true);
      try{
        const { data } = await API.get(
          `SBTenant/${orgId.tenantID}/AuditTool/GetAuditItems/${status}/${rowdata.chargeAuditItemID}/${rowdata.chargeAuditID}`,
          { hasDefaultURL: true }
        );
        if(data){
          handelAudititems()
          toast.success('Updated Successfully');

        }
        setLoading(false);
      }
      catch{
        setLoading(false);
      }
    }
    const renderViewButton = (rowData) => {
        return (
            <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => handelViewAudit(rowData)}
                title='In Eligibale'
            >
                <HoverImage
                    key='EyeIcon'
                    src={EyeIcon}
                    hoverSrc={EyeIconHover}
                    alt=''
                />
            </Button>
        );
    };
    const rendereligible = (rowData) => {
      if (hasPermission('GN'))
      return (
          <Button
              className='text-primary p-0 text-decoration-none'
              color='link'
              onClick={() => handelAll(rowData,1203)}
              title='Eligible'
              hidden={rowData.auditItemStatusID==1203}

          >
              <HoverImage
                  key='SaveIcon'
                  src={SaveIcon}
                  hoverSrc={SaveHoverIcon}
                  alt=''
              />
          </Button>
      );
  };
  const renderpending = (rowData) => {
    if (hasPermission('GN'))
    return (
        <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => handelAll(rowData,1202)}
            title='Pending '
            hidden={rowData.auditItemStatusID==1202}
        >
            <HoverImage
                key='Pause'
                src={Pending}
                hoverSrc={PendingHover}
                alt=''
            />
        </Button>
    );
};
const renderCancal = (rowData) => {
  if (hasPermission('GN'))
  return (
      <Button
          className='text-primary p-0 text-decoration-none'
          color='link'
          onClick={() => handelAll(rowData,1204)}
          title='Ineligible'
          hidden={rowData.auditItemStatusID==1204}
      >
          <HoverImage
              key='CancleIcon'
              src={CancleIcon}
              hoverSrc={CancleHoverIcon}
              alt=''
          />
      </Button>
  );
};

    const toggleView = (rowData) => {
        setOpenView(!isOpenView);
        setselectedRow(rowData);
    };
    const renderAttachementsButton = (rowData) => {
        if (hasPermission('AT'))
            return (
            <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => toggleAttachPODetailsDrawer(rowData)}
                title="Attachments"
            >
                <HoverImage
                    key='AttachIcon'
                    src={AttachIcon}
                    hoverSrc={AttachHoverIcon}
                    alt=''
                />
            </Button>
            )
    }
    const renderDeleteButton = (rowData) => {
      
             return (
            <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => toggle(rowData)}
            >
                <HoverImage
                    key='Download'
                    src={Delete}
                    hoverSrc={DeleteHower}
                    alt=''
                />
            </Button>
            )
    }
    const toggleCommentDrawer = (rowData) => {
        setCommentDrawer((pre) => !pre);
        setCommentRowData(rowData);
    };
    const hasPermission = (code) => {
      return ModuleAccess("ADT", code);
  }
    const cellRenderEdit = (rowData) => {
      console.log(rowData, "rowDAta1161");
        return (
            <div className='d-flex align-items-center'>
                {/* {renderViewButton(rowData)} */}
                {/* {rowData.auditItemStatusID==1202?renderpending(rowData):""}
                {rowData.auditItemStatusID == 1203 ? rendereligible(rowData) : "" }
                {rowData.auditItemStatusID == 1204 ? renderCancal(rowData): ""} */}
                {renderpending(rowData)}
                {rendereligible(rowData)}
                {renderCancal(rowData)}
                {renderAttachementsButton(rowData)}
                {/* {renderViewButton(rowData)} */}

                               
            </div>
        );
    };
   
    
    // const handleExport = async () => {
    //     const { access_token } =
    //         JSON.parse(localStorage.getItem('pharmaforce')) || {};
    //     const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
    //     // onExport(action, initialFilters);
    // };
   
   const handleExport = async () => {
           debugger;
           const filterObj = cloneDeep(search);
           if (columnFilters?.length > 0) {
             filterObj.filters = columnFilters;
           }
                 
           const { access_token } =
             JSON.parse(localStorage.getItem('pharmaforce')) || {};
       
             var additionalCriteria = {};
             additionalCriteria.IsSelectedColumn = false;
             additionalCriteria.OrgId = orgId.organizationID;
             // additionalCriteria.CEId = rowData.accumulatorID;
           // additionalCriteria.POId = 0;
           // additionalCriteria.OpaId = 0;
           // additionalCriteria.CEId = 0;
            additionalCriteria.ManufactureId = rowData.chargeAuditID;
       
           var payload = {};
           payload.tenantID = orgId.tenantID
           payload.gridCode = "audittoolitemexport";
           payload.fileTypeCode = "csv";
           payload.criteria = JSON.stringify(filterObj);
           payload.additionalCriteria = JSON.stringify(additionalCriteria);
           const { data } = await API.post(`export/queue`, payload, {
             hasExport: true,
           });
         //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
         //  onExport(action, initialFilters);
         };
         const dateFormateTime = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    const data1 = date !== null ? date?.toLocaleString('en-US', options).replace(",", "").replace(/\//g, "/") : "-"
    return data1;
  };
    let mainCol = [
        {
            dataField: 'edit',
            text: 'Options',
            cellRenderer: (rowData) => cellRenderEdit(rowData),
            width: 120,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },

        {
            dataField: 'accountType',
            text: 'Account Type',
            sort: false,
            width: 100,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.accountType),
            screenName: 'NewAuditScreen'
        },
        {
            dataField: 'dateofDrugadministration',
            text: 'Date of Drug Administration',
            sort: true,
            width: 200,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (row) => dateFormateTime(row.dateofDrugadministration),
        },
        {
            dataField: 'mrn',
            text: 'MRN #',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.mrn),
        },
        {
            dataField: 'visitNumber',
            text: 'Visit #',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.visitNumber),
        },
        {
            dataField: 'patientType',
            text: 'Patient Type',
            sort: true,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.patientType),
        },
        {
            dataField: 'serviceLocation',
            text: 'Service Location',
            sort: true,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.serviceLocation),
        },
        {
            dataField: 'chargeCode',
            text: 'Charge Code',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.chargeCode),
        
        },
        {
            dataField: 'chargeCodeDescription',
            text: 'Charge Description',
            sort: true,
            width: 280,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.chargeCodeDescription),
        },
        {
            dataField: 'ndc',
            text: 'NDC',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.ndc),
        },
        {
            dataField: 'ndcDescription',
            text: 'NDC Description',
            sort: true,
            width: 300,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.ndcDescription),
        },
        {
          dataField: 'quantity',
          text: 'Quantity',
          sort: true,
          width: 110,
          show: true,
          inputType: 'number',
          hideColFilter: false,
          cellRenderer: (row) => cellRendererCheck(row.quantity),
      },
      {
        dataField: 'bupp',
        text: 'BUPP',
        sort: true,
        width: 120,
        show: true,
        inputType: 'number',
        hideColFilter: false,
        cellRenderer: (row) => cellRendererCheck(row.bupp),
    },
    {
      dataField: 'accumulation',
      text: 'Accumulation',
      sort: true,
      width: 150,
      show: true,
      inputType: 'number',
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.accumulation),
  },
  {
    dataField: 'coveredEntity',
    text: 'CoveredEntity',
    sort: true,
    width: 280,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.coveredEntity),
  },
 
{
  dataField: 'accumulator',
  text: 'Accumulator',
  sort: true,
  width: 280,
  show: true,
  inputType: 'text',
  hideColFilter: false,
  cellRenderer: (row) => cellRendererCheck(row.accumulator),
},
{
  dataField: 'reason',
  text: 'Reason',
  sort: true,
  width: 140,
  show: true,
  inputType: 'text',
  hideColFilter: false,
  cellRenderer: (row) => cellRendererCheck(row.reason),
},
{
  dataField: 'providerNPI',
  text: 'Provider NPI',
  sort: true,
  width: 150,
  show: true,
  inputType: 'text',
  hideColFilter: false,
  cellRenderer: (row) => cellRendererCheck(row.providerNPI),
},
{
  dataField: 'providerName',
  text: 'Provider Name',
  sort: true,
  width: 150,
  show: true,
  inputType: 'text',
  hideColFilter: false,
  cellRenderer: (row) => cellRendererCheck(row.providerName),
},
{
  dataField: 'grossCharge',
  text: 'Gross Charge',
  sort: true,
  width: 140,
  show: true,
  inputType: 'number',
  hideColFilter: false,
  cellRenderer: (row) => currencyFormat(row.grossCharge),
},
{
  dataField: 'primaryPayor',
  text: 'Primary Payor',
  sort: true,
  width: 250,
  show: true,
  inputType: 'text',
  hideColFilter: false,
  cellRenderer: (row) => cellRendererCheck(row.primaryPayor),
},

{
  dataField: 'secondaryPayor',
  text: 'Secondary Payor ',
  sort: true,
  width: 250,
  show: true,
  inputType: 'text',
  hideColFilter: false,
  cellRenderer: (row) => cellRendererCheck(row.secondaryPayor),
},
{
  dataField: 'tertiaryPayor',
  text: 'Tertiary Payor',
  sort: true,
  width: 250,
  show: true,
  inputType: 'text',
  hideColFilter: false,
  cellRenderer: (row) => cellRendererCheck(row.tertiaryPayor),
},
{
  dataField: 'Facility',
  text: 'Facility',
  sort: true,
  width: 220,
  show: true,
  inputType: 'text',
  hideColFilter: false,
  cellRenderer: (row) => cellRendererCheck(row.facility),
},
{
  dataField: 'hcpcs',
  text: 'HCPCS',
  sort: true,
  width: 140,
  show: true,
  inputType: 'text',
  hideColFilter: false,
  cellRenderer: (row) => cellRendererCheck(row.hcpcs),
},   
{
  dataField: 'transactionID',
  text: 'Transaction ID',
  sort: true,
  width: 150,
  show: true,
  inputType: 'text',
  hideColFilter: false,
  cellRenderer: (row) => cellRendererCheck(row.transactionID),
},
{
  dataField: 'comment',
  text: 'Comment',
  sort: true,
  width: 140,
  show: true,
  inputType: 'text',
  hideColFilter: false,
  cellRenderer: (row) => cellRendererCheck(row.comment),
},

 

    ];
    const cellRenderLink = (rowData) => {
        // if (hasPermission('VWPO')) {
          return (
            <span
              className='text-decoration-underline d-inline-block cursor-pointer'
              onClick={() => handelWacPrice(rowData)}
            >
              {rowData}
            </span>
          );
        // }
      };
      const cellRender340BLink = (rowData) => {
        // if (hasPermission('VWPO')) {
          return (
            <span
              className='text-decoration-underline d-inline-block cursor-pointer'
              onClick={() => handel340BPrie(rowData)}
            >
              {rowData}
            </span>
          );
        // }
      };
      const cellRenderGpoPriceLink = (rowData) => {
        // if (hasPermission('VWPO')) {
          return (
            <span
              className='text-decoration-underline d-inline-block cursor-pointer'
              onClick={() => handelGpoPrice(rowData)}
            >
              {rowData}
            </span>
          );
        // }
      };
    const handlePODetails = (row) => {
        setisPODetailsOpen(!isPODetailsOpen);
        setDrawerPODetails('OrderDetails');
        // setPORowData(row);
      };
      const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {            
        callHandleAuditItems(filter);
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => { 
      if(hasColFilter){
       filter = { ...filter, filters: colChangedFilter }; 
      }         
        callHandleAuditItems(filter,hasColFilter);
    };
    const handleSearchColumnFilters = async (columnFilters) => {        
          //const filterObj = cloneDeep(search);
          if(columnFilters && columnFilters.length > 0){
           // filterObj.filters = [...filterObj.filters, ...columnFilters];
            setColumnFilters(columnFilters);
            search.filters=columnFilters;
          }
          search.currentPage= 1;         
          await handelAudititems();
        }

          const onHandleSort = (filter, hasColFilter) => {          
            callHandleAuditItems(filter, hasColFilter)
          };

          
       const callHandleAuditItems = (filter,hasColFilter) => {
            search.currentPage = filter.currentPage;
            search.pageSize = filter.pageSize;
            search.orderBy= filter.orderBy;
            search.order= filter.order;
            if(hasColFilter){
            search.filters = filter.filters;
            }       
            handelAudititems();
  }

      const handleFilterCancel = () => {
        search.filters=[];
        setColumnFilters([]);
        search.currentPage=1;
        handelAudititems();
    };

  return (
    <div>
              <div
            className='table-card scroll-table position-relative border-0 rounded pt-0'
            fixed-height={tableData?.length > 0 ? 'fixed-height' : 'default'}
        >
            <ReactStrapTable
                id='audit-table'
                height={550}
                fixedColumn
                width={1200}
                // reset={reset}
                // loading={loading}
                data={tableData?tableData:[]}
                columns={mainCol}
                collapseSider={collapseSider}
                toggleSider={toggleSider}
                showtoggle={true}
                hidefilter={false}
                // add={"Upload"}
                // addbutton={true}
                // buttononclick={toggle}
                // handelAddCoveredEntity={handelAddCoveredEntity}
                  onExport={handleExport}
                // filters={2}
                //  totalRecords={1}
                //  pageSize={20}
                //  currentPage={1}
              hasPagination={tableData.length > 0 ? true : false}
            filters={filters}
            pageSize={filters.pageSize}
            currentPage={filters.currentPage}
            totalRecords={totalRecords}            
            onPageChange={onHandlePageChange}
            onPageSizeChange={onPageSizeChange}
                handleSort={onHandleSort}
                onFilterCancel={handleFilterCancel}
                onSearchColumnFilters={handleSearchColumnFilters}
                // hasExportPermission={hasExportPermission}
            />
        </div>
        <Drawer
        direction="end"
        title="Add Audit Attachement"
        isOpen={commentDrawer}
        toggle={toggleAttachPODetailsDrawer}
        size="lg"
      >
        < AuditProgramNotes orgId = {orgId}   commentRowData = {commentRowData}  onClose={toggleAttachPODetailsDrawer}
                    selectedCoveredEntity={ceid}/>
      </Drawer>
      <Modal isOpen={modal} fade={false} toggle={toggle} className={props.className}>
        <ModalHeader toggle={toggle}><h5 className="f-15 text-primary font-weight-700 mt-2">
        Delete Aduit
    </h5></ModalHeader>
        <ModalBody>
<div>
<div>
    <h6>Do You wish to delete this Audit ? </h6>
</div>
      </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary"  hidden={!(hasPermission('DE'))} onClick={toggle}>Delete</Button>{' '}
          <Button color="primary" onClick={toggle}>Cancel</Button>{' '}

        </ModalFooter>
      </Modal>

    </div>
  )
}

export default GenerateAuditTable
